import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Missisipiimages from "../../Media/Kotwis/Missisipi/Missisipi";
import Davinciimages from "../../Media/Kotwis/Davinci/Davinci";
import Aethertonimages from "../../Media/Kotwis/Aetherton/Aetherton";
import Vermontimages from "../../Media/Kotwis/Vermont/Vermont";
import Averon10images from "../../Media/Kotwis/Averon/Averon 10/Averon10";
import Richmondimages from "../../Media/Kotwis/Richmond/Richmond";
import Leyora12images from "../../Media/Kotwis/Leyora/Leyora 12/Leyora12";
import Orleans8images from "../../Media/Orleans/Orleans 8/Orleans8";
import Morrington7images from "../../Media/Kotwis/Morrington/Morrington 7/Morrington";

const imageMap = {
  Missisipiimages,
  Davinciimages,
  Aethertonimages,
  Vermontimages,
  Richmondimages,
  Averon10images,
  Leyora12images,
  Orleans8images,
  Morrington7images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <h1>Our Residentials</h1>
      <h2>Cicilan Start From 6 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
